import { render, staticRenderFns } from "./siteFooter.vue?vue&type=template&id=6b465eca&scoped=true"
import script from "./siteFooter.vue?vue&type=script&lang=js"
export * from "./siteFooter.vue?vue&type=script&lang=js"
import style0 from "./siteFooter.vue?vue&type=style&index=0&id=6b465eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b465eca",
  null
  
)

export default component.exports